import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83cdc8c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert__progress-animation" }, null, -1))

import { onMounted, ref, Ref, toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInfoModal',
  props: {
    showInfoModal: { type: Boolean },
    position: { default: 'bottom-left' },
    isError: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const timer: Ref<number | undefined> = ref(undefined);
const closeInfoModal = () => {
  emit('close');
};
const { showInfoModal } = toRefs(props);

onMounted(() => {
  clearInterval(timer.value);
  timer.value = undefined;
  if (showInfoModal) {
    timer.value = setTimeout(() => {
      closeInfoModal();
    }, 5000);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_unref(showInfoModal))
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#modalWindow"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{ 'top-right': _ctx.position === 'top-right', isError: _ctx.isError }, "alert"])
        }, [
          _renderSlot(_ctx.$slots, "default"),
          _createVNode(_component_base_icon, {
            class: "alert__close-icon",
            clickable: "",
            color: "#ffffff",
            "font-size": "20",
            name: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeInfoModal()))
          }),
          _createElementVNode("div", {
            class: _normalizeClass([{ isError: _ctx.isError }, "alert__progress"])
          }, null, 2),
          _hoisted_1
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})